/* eslint-disable max-statements */
import { OrderBulkDto } from '@tiendanube/common';
import { useNavegate } from 'App/hooks';
import { NUVEM_ENVIO_ORDERS_ROUTES } from '../../routes';

interface GoToPrintNuvemEnvioLabelsPageProps {
  ids: string[];
  bulkOrders: OrderBulkDto[];
}

function useGoToPrintNuvemEnvioLabelsPage() {
  const { goTo } = useNavegate();

  const goToPrintNuvemEnvioLabelsPage = (
    params: GoToPrintNuvemEnvioLabelsPageProps,
  ) => {
    const { ids, bulkOrders } = params;

    const fulfillmentOrdersIds = bulkOrders
      .filter((order) => ids.includes(order.orderId))
      .flatMap((order) =>
        order.fulfillments.map((fulfillment) => fulfillment.fulfillmentId),
      )
      .slice(0, 50);

    if (!fulfillmentOrdersIds?.length) return;

    goTo(
      `${
        NUVEM_ENVIO_ORDERS_ROUTES.ordersNuvemEnvioPrintLabelStatus
      }?ids=${encodeURIComponent(fulfillmentOrdersIds.join(','))}`,
    );
  };

  return { goToPrintNuvemEnvioLabelsPage };
}

export default useGoToPrintNuvemEnvioLabelsPage;
